package com.partejar.app.core.di

import com.russhwolf.settings.Settings
import com.partejar.app.core.session.SessionTokenStore
import com.partejar.app.core.session.SettingsSessionTokenStore
import com.partejar.app.core.session.BiometricPreferences
import com.partejar.app.core.session.SettingsBiometricPreferences
import org.koin.dsl.module

val storageModule = module {
    single { Settings() }
    single { com.partejar.app.feature.calendar.CalendarSyncPreferences(get()) }
    single<SessionTokenStore> { SettingsSessionTokenStore(get()) }
    single<BiometricPreferences> { SettingsBiometricPreferences(get()) }
}
